<template>
  <section>
    <h1>Client Details</h1>
    Client ID {{ $route.params.id }}
    Client Name: {{ name }}
    Client Email: {{ email }}
  </section>
</template>

<script>
export default {
  name: 'Client',
  props: ['id'],
  data () {
    return {
      loading: false,
      name: '',
      email: ''
    }
  },
  async created () {
    console.log('created event')
    this.getClient()
  },
  methods: {
    async getClient () {
      this.name = 'Client Test'
      this.email = 'client@example.com'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Client.vue